<template>
    <div class="flex-grow-1 d-flex flex-column min-width-0 lh-1">
        <div v-if="inconsistentVersions">
            <template v-if="size === 'sm'">
                <h4
                    class="mb-1 title text-danger font-weight-400"
                    :class="{'expanded': isExpanded}">
                    <font-awesome-icon icon="exclamation-circle" />
                    {{ $t('eventRegistration.deprecatedVersion') }}
                </h4>
                <h6 class="mb-0 text-danger">
                    {{ $t('eventRegistration.pleaseReloadPageForVersion') }}
                </h6>
            </template>
            <template v-if="size === 'md'">
                <h1 class="mb-1 text-danger font-weight-400">
                    <font-awesome-icon icon="exclamation-circle" />
                    {{ $t('eventRegistration.deprecatedVersion') }}
                </h1>
                <h4 class="mb-0 text-danger">
                    {{ $t('eventRegistration.pleaseReloadPageForVersion') }}
                </h4>
            </template>
        </div>
        <div v-else-if="eventData">
            <template v-if="size === 'sm'">
                <h5 class="mb-0 d-flex align-items-center gap-2">
                    {{
                        changeWordingRegistrationBuy ? $t('eventRegistration.order') : $t('eventRegistration.registration')
                    }}
                    <OccupancyBadge />
                </h5>
                <template v-if="eventData.shortText && eventData.id">
                    <h3
                        class="mb-1 title font-weight-400"
                        :class="{'expanded': isExpanded}">
                        <a
                            v-if="eventDirectLink"
                            :href="eventDirectLink"
                            target="_blank">{{ eventData.shortText }}</a>
                        <span v-else>{{ eventData.shortText }}</span>
                    </h3>
                    <h6
                        v-if="eventData.startDate && eventData.endDate"
                        class="mb-0">
                        {{ $df($moment(eventData.startDate), 'dateShort') }} -
                        {{ $df($moment(eventData.endDate), 'dateShort') }}
                    </h6>
                </template>
                <template v-else>
                    <h3
                        class="mb-1 title text-danger"
                        :class="{'expanded': isExpanded}">
                        <font-awesome-icon icon="exclamation-circle" />
                        {{ $t('eventRegistration.noEventData') }}
                    </h3>
                    <h5 class="mb-0 text-danger">
                        {{ $t('eventRegistration.pleaseReloadPage') }}
                    </h5>
                </template>
            </template>
            <template v-if="size === 'md'">
                <h4 class="mb-0 d-flex align-items-center gap-2">
                    <span>
                        {{
                            changeWordingRegistrationBuy ? $t('eventRegistration.order') : $t('eventRegistration.registration')
                        }}
                    </span>
                    <OccupancyBadge />
                </h4>
                <template v-if="eventData.shortText && eventData.id">
                    <h2 class="mb-1 font-weight-400">
                        <a
                            v-if="eventDirectLink"
                            :href="eventDirectLink"
                            target="_blank">{{ eventData.shortText }}</a>
                        <span v-else>{{ eventData.shortText }}</span>
                    </h2>
                    <small
                        v-if="eventData.startDate && eventData.endDate"
                        class="mb-0">
                        {{ $df($moment(eventData.startDate), 'dateLong') }} -
                        {{ $df($moment(eventData.endDate), 'dateLong') }}
                    </small>
                </template>
                <template v-else>
                    <h1
                        class="mb-1 text-danger"
                        :class="{'expanded': isExpanded}">
                        <font-awesome-icon icon="exclamation-circle" />
                        {{ $t('eventRegistration.noEventData') }}
                    </h1>
                    <h4 class="mb-0 text-danger">
                        {{ $t('eventRegistration.pleaseReloadPage') }}
                    </h4>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import clientVersionMixin from "@/mixins/clientVersionMixin";

export default {
    name: "EventTitleAndDate",
    mixins: [mainRegistrationMixin, clientVersionMixin],
    props: {
        size: {
            type: String,
            default: "md"
        },
        isExpanded: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            showEventPreview: false
        }
    },
    computed: {
        eventDate() {
            return eventDate
        },
        appVersion() {
            return this.clientVersion || '(no version detected)'
        },
        remoteVersion() {
            return this.$store.state.registration?.remoteVersion
        },
        inconsistentVersions() {
            return this.remoteVersion && this.remoteVersion !== this.appVersion
        },
        eventDirectLink() {
            if(this.eventData.id && this.eventData.public && (!this.eventData.showFrom || this.$moment().isAfter(this.eventData.showFrom)) && (!this.eventData.showUntil || this.$moment().isBefore(this.eventData.showUntil))) {
                return "https://" + location.hostname + "/reg/veranstaltung/" + this.eventData.id;
            }
            return null
        }
    }
}
</script>

<style lang="scss" scoped>
.occupancy-badge {
    color: $white;
    text-transform: none;

    &.badge-success {
        background-color: $success;
    }

    &.badge-danger {
        background-color: $danger;
    }

    &.badge-warning {
        background-color: $warning;
    }

    &.badge-info {
        background-color: $info;
    }
}


.title {
    width: 70%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    transition: width $registration-transition-duration ease;
}

.title.expanded {
    width: 90%;
}

.min-width-0 {
    min-width: 0;
}
</style>
